var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.27002 3.47812C5.27002 2.40578 6.13564 1.54016 7.20798 1.54016H9.79193C10.8643 1.54016 11.7299 2.40578 11.7299 3.47812C11.7299 3.83342 11.4392 4.12411 11.0839 4.12411H5.91601C5.56071 4.12411 5.27002 3.83342 5.27002 3.47812Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2145 9.93798C12.2145 10.2028 11.9949 10.4225 11.73 10.4225H11.084V12.5219C11.084 13.5943 10.2184 14.4599 9.14606 14.4599H7.85409C6.78175 14.4599 5.91612 13.5943 5.91612 12.5219V10.4225H5.27014C5.00528 10.4225 4.78564 10.2028 4.78564 9.93798C4.78564 9.67313 5.00528 9.45349 5.27014 9.45349H11.73C11.9949 9.45349 12.2145 9.67313 12.2145 9.93798Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3759 4.77002H4.624C3.33202 4.77002 2.68604 5.41601 2.68604 6.70798V9.93792C2.68604 11.2299 3.33202 11.8759 4.624 11.8759H4.86624C5.08922 11.8759 5.26999 11.6951 5.26999 11.4721C5.26999 11.2492 5.08349 11.0751 4.87491 10.9963C4.44712 10.8347 4.13951 10.4194 4.13951 9.93792C4.13951 9.31777 4.64984 8.80744 5.26999 8.80744H11.7299C12.35 8.80744 12.8603 9.31777 12.8603 9.93792C12.8603 10.4194 12.5527 10.8347 12.1249 10.9963C11.9164 11.0751 11.7299 11.2492 11.7299 11.4721C11.7299 11.6951 11.9106 11.8759 12.1336 11.8759H12.3759C13.6678 11.8759 14.3138 11.2299 14.3138 9.93792V6.70798C14.3138 5.41601 13.6678 4.77002 12.3759 4.77002ZM7.20795 7.83846H5.26999C5.00513 7.83846 4.7855 7.61882 4.7855 7.35397C4.7855 7.08912 5.00513 6.86948 5.26999 6.86948H7.20795C7.4728 6.86948 7.69244 7.08912 7.69244 7.35397C7.69244 7.61882 7.4728 7.83846 7.20795 7.83846Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.8ec533c88b1a8799c11c5989ed9aa05d.svg";
export { ForwardRef as ReactComponent };